import React, {Component, useRef} from 'react';
import {connect} from 'react-redux';
import {Panel} from 'primereact/components/panel/Panel';
import {withRouter} from 'react-router-dom';
import {DataTable} from "primereact/components/datatable/DataTable";
import {Column} from "primereact/components/column/Column";
import {Button} from "primereact/components/button/Button";
import {Card} from 'primereact/components/card/Card';
import {Dialog} from "primereact/components/dialog/Dialog";
import {userService} from "../servicios/userService";
import Layout from 'react-comun-seps/lib/components/Layout';
import {datosLocalesHelper} from "react-comun-seps/lib/helpers/datosLocalesHelper";
import {history} from "../helpers/history";
import {Checkbox} from 'primereact/components/checkbox/Checkbox';
import {ScrollPanel} from "primereact/components/scrollpanel/ScrollPanel";

class AcuerdosContainer extends Component {
  constructor(props) {
    super(props);
    this.guardarConcentimiento2 = this.guardarConcentimiento2.bind(this);
    this.DownloadFile = this.DownloadFile.bind(this);

    this.state = {
      visible: false,
      verAcuerdo: false,
      acuerdoConfidencialidad: null,
      bannerImagen: null,
      codParamAcuerdo: null,
      numRuc: null,
      razonSocial: null,
      acuerdosList: [],
      pasarSistemas: false,
      checked: false,
      pdf: null,
      acuerdoBites: null,
      activarAceptar: true,
      paraReporte: {}
    }
  }

  componentDidMount() {
    userService.banner().then(
      respuestaBanner => {
        if (respuestaBanner !== '') {
          this.setState({bannerImagen: `data:image/png;base64,${respuestaBanner}`})
          this.setState({visible: true})
        } else {
          this.setState({visible: false})
        }
      }
    )
    this.updateAcuerdos();
  }

  updateAcuerdos() {
    let userDecode = datosLocalesHelper();
    let user = userDecode.tokenSeps.idusuario;
    const {dispatch} = this.props;
    userService.acuerdos(user).then(
      lista => {
        if (!lista) {
          history.push('/sistemas')
          window.location.reload();
        } else {
          if (lista.length > 0) {
            this.setState({acuerdosList: lista})
          } else if (lista.length === 0 && this.state.visible === false) {
            history.push('/sistemas')
            this.setState({pasarSistemas: true})
          }
        }
      },
      error => {
        userService.logout()
        history.push('/sistemas')
        window.location.reload();
      }
    )
  }

  guardarConcentimiento2() {
    let userDecode = datosLocalesHelper();
    let user = userDecode.tokenSeps.idusuario;
    let datos = {
      codParamAcuerdoConfid: this.state.codParamAcuerdo,
      codUsuario: user,
      txtPlantillaAcuerdo: this.state.acuerdoConfidencialidad,
      ruc: this.state.numRuc,
      razonSocial: this.state.razonSocial
    }
    this.setState({checked: false})
    userService.guardarConcentimiento(datos).then(
      respuesta => {
        if (respuesta === 'OK') {
          this.updateAcuerdos();
          this.setState({verAcuerdo: false})
        }
      }
    )
  }

  DownloadFile = async () => {
    this.setState({checked: false})
    userService.descargarAcuerdo(this.state.paraReporte).then(
      respuesta => {
        let binaryString = window.atob(respuesta);
        let binaryLen = binaryString.length;
        let bytes = new Uint8Array(binaryLen);
        for (let i = 0; i < binaryLen; i++) {
          bytes[i] = binaryString.charCodeAt(i);
        }
        let blob = new Blob([bytes], {type: "application/pdf"});
        let link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "acuerdo" + this.state.paraReporte.ruc + ".pdf";
        link.click();
      }
    )
    this.setState({activarAceptar: false})
  }

  render() {
    let cargando = typeof sistemas === "undefined" && Object.getOwnPropertyNames(alert).length === 0;
    return (
      <div className="layout-main-sistemas">
        {!cargando && <Layout staticMenuDesktopInactive={true} activarMenuPrincipal={false} body={
          <div className="dashboard global-sales ui-panel-content">
            <Card title="Acuerdos de aceptación de uso de información">
              <p className="m-2">
                Por favor, debe aceptar todos los acuerdos de uso de datos antes de poder continuar </p>
            </Card>
            <Panel>
              <DataTable value={this.state.acuerdosList} paginator={true} rows={10}>
                <Column field="numRuc" header='Ruc' style={{width: "10%"}}/>
                <Column field="razonSocial" header='Razón social'/>
                <Column field="nomParametro" header='Acuerdo y/o concentimiento'/>
                <Column
                  header="Acciones"
                  style={{width: "6%"}}
                  bodyStyle={{
                    textAlign: "center",
                    overflow: "visible",
                    justifyContent: "center",
                    width: "6%"
                  }}
                  frozen={false}
                  body={(rowData) =>
                    <Button
                      icon="fa fa-check"
                      className="p-button p-button-primary p-mr-1"
                      onClick={() => {
                        userService.verAcuerdo(rowData.codParamAcuerdo).then(
                          respuestaAcuerdo => {
                            const fecha = new Date()
                            const dia = fecha.getDate();
                            const mes = fecha.getMonth() + 1;
                            const anio = fecha.getFullYear();
                            const org = rowData.razonSocial ? rowData.razonSocial.replaceAll(" ", " &nbsp; ") : null
                            const fechaFinal = dia + '/' + mes + '/' + anio
                            const parrafoModificado1 = respuestaAcuerdo[0].txtPlantillaAcuerdo.replace("{1}", localStorage.usuarioNombre);
                            const parrafoModificado2 = parrafoModificado1.replace("{2}", localStorage.usuarioCI);
                            const parrafoModificado3 = parrafoModificado2.replace("{3}", rowData.numRuc);
                            const parrafoModificado4 = parrafoModificado3.replace("{4}", localStorage.usuarioCorreo);
                            const parrafoModificado5 = parrafoModificado4.replace("{5}", org + "&nbsp;");
                            const parrafoModificado6 = parrafoModificado5.replace("{6}", fechaFinal);
                            this.setState({acuerdoConfidencialidad: parrafoModificado6})
                          }
                        )
                        const fecha = new Date()
                        const dia = fecha.getDate();
                        const mes = fecha.getMonth() + 1;
                        const anio = fecha.getFullYear();
                        const fechaFinal = dia + '/' + mes + '/' + anio
                        let datos = {
                          idReport: rowData.codParamAcuerdo,
                          usuarioNombre: localStorage.usuarioNombre,
                          usuarioCI: localStorage.usuarioCI,
                          ruc: rowData.numRuc,
                          razonSocial: rowData.razonSocial,
                          correo: localStorage.usuarioCorreo,
                          fechaFinal: fechaFinal
                        }

                        this.setState({
                          paraReporte: datos,
                          verAcuerdo: true,
                          codParamAcuerdo: rowData.codParamAcuerdo,
                          numRuc: rowData.numRuc,
                          razonSocial: rowData.razonSocial
                        })
                      }}
                      disabled={undefined}
                      tooltipOptions={{position: "bottom"}}
                      tooltip=""
                    />
                  }
                />
              </DataTable>
            </Panel>
            <Dialog visible={this.state.visible} modal={true} onHide={() => {
              this.setState({visible: false})
              if (this.state.acuerdosList.length === 0) {
                history.push('/sistemas')
              }
            }}>
              <img src={this.state.bannerImagen} alt="Imagen" style={{width: '100%', height: '100%'}}/>
            </Dialog>
            <Dialog visible={this.state.verAcuerdo} style={{width: '160vh', height: '80vh'}}
                    onHide={() => this.setState({verAcuerdo: false, activarAceptar: true})}>
              <ScrollPanel style={{height: '390px'}}>
                <div id="divToPrint" dangerouslySetInnerHTML={{__html: this.state.acuerdoConfidencialidad}}
                     style={{marginLeft: '3%', marginRight: '3%', marginTop: '3%', marginBottom: '3%'}}/>
                {/* style={{fontSize: '12px', marginLeft: '20px', marginRight: '20px' }} */}
                <br/>
                <div>
                  <Checkbox inputId="cb1" onChange={e => this.setState({checked: e.checked})}
                            checked={this.state.checked}></Checkbox>
                  <label htmlFor="cb1" className="p-checkbox-label">Aceptar acuerdo</label>

                  {this.state.checked === true &&
                    <Button responsive={true} label="Descargar acuerdo" style={{marginLeft: "10px"}}
                            onClick={this.DownloadFile}> </Button>}
                  <br/>
                  <Button label="Aceptar" disabled={this.state.activarAceptar} onClick={this.guardarConcentimiento2}/>
                </div>
              </ScrollPanel>
            </Dialog>
          </div>
        }/>}
      </div>

    );
  }
}

function mapStateToProps(state) {
  const {authentication, alert} = state;
  const {sistemas, user, acuerdos, acuerdo} = authentication;
  return {
    sistemas, user, alert, acuerdos, acuerdo
  };
}

const connectedAcuerdosContainer = withRouter(connect(mapStateToProps)(AcuerdosContainer));
export {connectedAcuerdosContainer as AcuerdosContainer};